
// const  BaseUrl = 'http://localhost:5001/self-gens/us-central1/sunny';
const BaseUrl = '';
export {BaseUrl};